import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'vi',
  months: [
    'tháng Một',
    'tháng Hai',
    'tháng Ba',
    'tháng Tư',
    'tháng Năm',
    'tháng Sáu',
    'tháng Bảy',
    'tháng Tám',
    'tháng Chín',
    'tháng Mười',
    'tháng Mười Một',
    'tháng Mười Hai',
  ],
  monthsShort: [
    'tháng 1',
    'tháng 2',
    'tháng 3',
    'tháng 4',
    'tháng 5',
    'tháng 6',
    'tháng 7',
    'tháng 8',
    'tháng 9',
    'tháng 10',
    'tháng 11',
    'tháng 12',
  ],
  weekdays: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
  weekdaysMin: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  weekdaysShort: ['CN', 'Th 2', 'Th 3', 'Th 4', 'Th 5', 'Th 6', 'Th 7'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM, YYYY',
    'LL-D': 'MMMM [năm] YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'HH:mm, D MMMM YYYY',
    'LLL-Y': 'HH:mm, D MMMM',
    LLLL: 'HH:mm dddd, D MMMM YYYY',
    'LLLL-Y': 'HH:mm dddd, D MMMM',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'h:mm A, D MMM YYYY',
    'lll-Y': 'h:mm A, D MMM',
    llll: 'h:mm A ddd, D MMM YYYY',
    'llll-Y': 'h:mm A ddd, D MMM',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'H:mm, D MMMM, YYYY ([GMT]Z)',
  },
  meridiem: { am: 'SA', pm: 'CH', AM: 'SA', PM: 'CH' },
  past: {
    y: { other: '%s năm trước' },
    M: { other: '%s tháng trước' },
    w: { other: '%s tuần trước' },
    d: { other: '%s ngày trước' },
    h: { other: '%s giờ trước' },
    m: { other: '%s phút trước' },
    s: { other: '%s giây trước' },
  },
  future: {
    y: { other: 'sau %s năm' },
    M: { other: 'sau %s tháng' },
    w: { other: 'sau %s tuần' },
    d: { other: 'sau %s ngày' },
    h: { other: 'sau %s giờ' },
    m: { other: 'sau %s phút' },
    s: { other: 'sau %s giây' },
  },
  pastLong: {
    y: { other: '%s năm trước' },
    M: { other: '%s tháng trước' },
    w: { other: '%s tuần trước' },
    d: { other: '%s ngày trước' },
    h: { other: '%s giờ trước' },
    m: { other: '%s phút trước' },
    s: { other: '%s giây trước' },
  },
  futureLong: {
    y: { other: 'sau %s năm' },
    M: { other: 'sau %s tháng' },
    w: { other: 'sau %s tuần' },
    d: { other: 'sau %s ngày' },
    h: { other: 'sau %s giờ' },
    m: { other: 'sau %s phút' },
    s: { other: 'sau %s giây' },
  },
  abbr: {
    y: { other: '%s năm' },
    M: { other: '%s tháng' },
    w: { other: '%s tuần' },
    d: { other: '%s ngày' },
    h: { other: '%s giờ' },
    m: { other: '%s phút' },
    s: { other: '%s giây' },
  },
  full: {
    y: { other: '%s năm' },
    M: { other: '%s tháng' },
    w: { other: '%s tuần' },
    d: { other: '%s ngày' },
    h: { other: '%s giờ' },
    m: { other: '%s phút' },
    s: { other: '%s giây' },
  },
  justNow: 'Vừa xong',
  yesterday: 'Hôm qua',
  today: 'Hôm nay',
  tomorrow: 'Ngày mai',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM, YYYY', end: 'D MMMM, YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM, YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM, YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM, YYYY', end: 'D MMM, YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM, YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM, YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM, YYYY', end: 'ddd, D MMM, YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM, YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'H:mm, D MMM, YYYY', end: 'H:mm, D MMM, YYYY' },
    mt: { start: 'H:mm, D MMM', end: 'H:mm, D MMM' },
    dt: { start: 'H:mm, D MMM', end: 'H:mm, D MMM' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'H:mm, D MMM, YYYY', end: 'H:mm, D MMM, YYYY ([GMT]Z)' },
    'mt+to': { start: 'H:mm, D MMM', end: 'H:mm, D MMM ([GMT]Z)' },
    'dt+to': { start: 'H:mm, D MMM', end: 'H:mm, D MMM ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'vi';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'SA' : 'SA';
    } else {
      return isLowerCase ? 'CH' : 'CH';
    }
  },
};
